import { Text, Stack, Group, Box } from '@mantine/core';
import classes from './WelcomeContent.module.css';

interface QuickStartPrompt {
  id: string;
  text: string;
  onClick?: (text: string) => void;
}

interface WelcomeContentProps {
  userName?: string;
  quickStartPrompts?: QuickStartPrompt[];
  onPromptClick?: (text: string) => void;
  isSidebarVisible?: boolean;
  titleOverride?: string;
  description?: string;
}

const defaultQuickStartPrompts: QuickStartPrompt[] = [
  {
    id: '1',
    text: 'Proofread the following text and outline any issues with spelling, grammar, or clarity: [text]'
  },
  {
    id: '2', 
    text: 'Write me a professional email based on the following bullet points: [text]'
  },
  {
    id: '3',
    text: 'Summarise the key points and arguments of the following research paper: [text]'
  }
];

export const WelcomeContent = ({
  userName = 'User',
  quickStartPrompts = defaultQuickStartPrompts,
  onPromptClick,
  isSidebarVisible = true,
  titleOverride,
  description,
}: WelcomeContentProps) => {
  const handlePromptClick = (text: string) => {
    onPromptClick?.(text);
  };

  return (
    <Box className={classes.container}>
      {/* Greeting at the top */}
      <Box className={classes.greetingSection}>
        <Stack gap={6} align="center">
          <Text className={classes.greeting}>
            {titleOverride ?? `Hello ${userName}, how can I help?`}
          </Text>
          {titleOverride && description && (
            <Text size="sm" c="dimmed" ta="center" className={classes.description}>
              {description}
            </Text>
          )}
        </Stack>
      </Box>
      
      {/* Spacer to push Quick Start to bottom */}
      <Box className={classes.spacer} />
      
      {/* Quick Start prompts at the bottom */}
       <Stack 
        gap="sm" 
        align="center" 
        className={`${classes.quickStartSection} ${!isSidebarVisible ? classes.quickStartSectionHiddenSidebar : ''}`}
      >
        <Text size="sm" className={classes.quickStartLabel} ta="center">
          Quick Start
        </Text>
        <Group gap={18} justify="center" wrap="wrap" style={{ width: '100%' }}>
          {quickStartPrompts.map(prompt => (
            <Box
              key={prompt.id}
              className={classes.promptCard}
              onClick={() => handlePromptClick(prompt.text)}
              style={{ cursor: onPromptClick ? 'pointer' : 'default' }}
            >
              <Text
                size="sm"
                ta="left"
                className={classes.promptCardText}
              >
                {prompt.text}
              </Text>
            </Box>
          ))}
        </Group>
      </Stack>
    </Box>
  );
};

export type { WelcomeContentProps, QuickStartPrompt };
